import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useField } from "formik";
import renderChildren from "../renderChildren";

export const Input = ({ node, name, size, children, "data-no-label":data_no_label, InputLabelProps, ...props }: any) => {
    const [field, meta] = useField(name);
    InputLabelProps = InputLabelProps || {}

    if(!isEmpty(field.value) || isNumber(field?.value) || !isEmpty(props?.defaultValue) || isNumber(props?.defaultValue)){
        Object.assign(InputLabelProps, { shrink: true })
    }

    // ✅ FIX 1: tìm slot trong node.children (AST),
    // KHÔNG dùng children prop (đã bị render thành ReactNode rồi)
    const startAdornmentSlot = node?.children?.find(
        (x: any) => x.type === "slot" && x.props?.name === "startAdornment"
    );

    const endAdornmentSlot = node?.children?.find(
        (x: any) => x.type === "slot" && x.props?.name === "endAdornment"
    );

    const InputProps = {
        startAdornment: startAdornmentSlot?.children?.length
            ? (
                <InputAdornment position="start">
                    {renderChildren(startAdornmentSlot.children)}
                </InputAdornment>
            )
            : undefined,

        // ✅ FIX 2: endAdornment dùng đúng biến endAdornmentSlot
        // (code cũ dùng endAdornment?.children nhưng endAdornment là slot node,
        //  không phải ReactNode — cần .children để render bên trong)
        endAdornment: endAdornmentSlot?.children?.length
            ? (
                <InputAdornment position="end">
                    {renderChildren(endAdornmentSlot.children)}
                </InputAdornment>
            )
            : undefined,
    };

    return (
        <TextField
            {...field}
            // ✅ FIX 3: truyền node xuống để InputNode
            // tự tìm slot trong AST — renderer truyền node
            // nhưng không forward vào TextField (tránh unknown DOM prop)
            {...{
             ...{ InputLabelProps },
             ...{ InputProps }
            }}
            value={field.value || ''}
            label={data_no_label ? null: (props.label ?? name)}
            fullWidth={props.fullWidth ?? true}
            margin="normal"
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
            size={size ?? "small"}
            {...props}
        />
    );
};

export default Input;
